import { ActionEditProps } from "components/Actions/pluginRegistry";

export function ValueInPropertiesOrErrorsHasChanged(keysObject: Record<string, string>, newProps: ActionEditProps, props: ActionEditProps) {
    return newProps.errors !== props.errors || Object.keys(keysObject).some((p) => newProps.properties[p] !== props.properties[p]);
}
